export const CDN_URL = "https://image.tmdb.org/t/p/original";

export const BASE_URL = "https://api.themoviedb.org/3";

export const API_KEY = "?api_key=a34b3f8b17f2cd887f4d28e55e96402b";

export const VIDEO_URL = "https://www.youtube.com//watch?v=";

export const SEARCH_QUERY = BASE_URL + "/search/movie?" + API_KEY + "&query=";
